import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app/app.component';
import {
    AbstractControl,
    FormControl,
    FormsModule,
    ReactiveFormsModule,
    ValidationErrors
} from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyNumericInputComponent } from './shared/formly/formly-numeric-input/formly-numeric-input.component';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { FormlyAttributes } from '@ngx-formly/core/lib/templates/formly.attributes';
import { FormlyButtonComponent } from './shared/formly/formly-button/formly-button.component';
import { FormlyAnchorTagComponent } from './shared/formly/formly-anchor-tag/formly-anchor-tag.component';
import { FormlyRepeatingSectionComponent } from './shared/formly/formly-repeating-section/formly-repeating-section.component';
import { FormlyRepeatingSectionSummaryComponent } from './shared/formly/formly-repeating-section-summary/formly-repeating-section-summary.component';
import { FormlyAddressAutopopulateComponent } from './shared/formly/formly-address-autopopulate/formly-address-autopopulate.component';
import { FormlyLabelComponent } from './shared/formly/formly-label/formly-label.component';
import {
    IpValidator,
    ssnValidator,
    emailValidator,
    invalidEmailMessage,
    invalidSSN,
    maxLengthValidationMessage,
    maxValidationMessage,
    minLengthValidationMessage,
    minValidationMessage
} from './core/utility/formly-validators';
import { FormlyResidenceDurationComponent } from './shared/formly/formly-residence-duration/formly-residence-duration.component';
import { FormlyLabelWithModalComponent } from './shared/formly/formly-label-with-modal/formly-label-with-modal.component';
import { FormlySSNInputComponent } from './shared/formly/formly-ssn-input/formly-ssn-input.component';
import { FormlyDownPctAmtComponent } from './shared/formly/formly-down-pct-amt/formly-down-pct-amt.component';
import { FormlyCurrencyInputComponent } from './shared/formly/formly-currency-input/formly-currency-input.component';
import { FormlyPhoneNumberComponent } from './shared/formly/formly-phone-number/formly-phone-number.component';
import { FormlyMultiSelectCheckboxComponent } from './shared/formly/formly-multi-select-checkbox/formly-multi-select-checkbox.component';
import { VerticalPanesComponent } from './admin/test/vertical-panes/vertical-panes.component';
import { RichTextEditorComponent } from './admin/test/rich-text-editor/rich-text-editor.component';
import { QuillConfigModule, QuillModule } from 'ngx-quill';
import { QRCodeModule } from 'angularx-qrcode';
import { AngularSplitModule } from 'angular-split';
import { NgApexchartsModule } from 'ng-apexcharts';

@NgModule({
    imports: [
        // angular
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,

        // core & shared
        CoreModule,
        SharedModule,

        // app
        AppRoutingModule,
        //DragDirective,

        // required to fix "NullInjectorError: No provider for MatDialogRef"
        // also the MatDialogRef in the providers section below
        MatDialogModule,
        NgApexchartsModule,
        QuillModule,
        QuillConfigModule,
        QuillModule.forRoot(),
        QRCodeModule,
        AngularSplitModule,

        FormlyBootstrapModule,
        FormlyModule.forRoot({
            types: [
                {
                    name: 'numericInput',
                    component: FormlyNumericInputComponent,
                    wrappers: ['form-field']
                },
                {
                    name: 'ssnInput',
                    component: FormlySSNInputComponent,
                    wrappers: ['form-field']
                },
                {
                    name: 'anchorTag',
                    component: FormlyAnchorTagComponent,
                    wrappers: ['form-field']
                },
                {
                    name: 'repeatingSection',
                    component: FormlyRepeatingSectionComponent
                },
                {
                    name: 'repeatingSectionSummary',
                    component: FormlyRepeatingSectionSummaryComponent
                },
                {
                    name: 'button',
                    component: FormlyButtonComponent,
                    wrappers: ['form-field'],
                    defaultOptions: {
                        props: {
                            btnType: 'default',
                            type: 'button'
                        }
                    }
                },
                {
                    name: 'input-address-autocomplete',
                    component: FormlyAddressAutopopulateComponent
                },
                {
                    name: 'multi-select-checkbox',
                    component: FormlyMultiSelectCheckboxComponent
                },
                { name: 'label', component: FormlyLabelComponent },
                {
                    name: 'residenceDuration',
                    component: FormlyResidenceDurationComponent
                },
                { name: 'downPctAmt', component: FormlyDownPctAmtComponent },
                {
                    name: 'labelWithModal',
                    component: FormlyLabelWithModalComponent
                },
                {
                    name: 'input-currency',
                    component: FormlyCurrencyInputComponent
                },
                { name: 'input-phone', component: FormlyPhoneNumberComponent }
            ],
            validators: [
                { name: 'email', validation: emailValidator },
                { name: 'ip', validation: IpValidator },
                { name: 'ssn', validation: ssnValidator }
            ],

            validationMessages: [
                { name: 'required', message: 'This field is required' },
                { name: 'minLength', message: minLengthValidationMessage },
                { name: 'maxLength', message: maxLengthValidationMessage },
                { name: 'min', message: minValidationMessage },
                { name: 'max', message: maxValidationMessage },
                { name: 'email', message: invalidEmailMessage },
                { name: 'ssn', message: invalidSSN }
            ]
        })
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        AppComponent,
        VerticalPanesComponent
        //DragDirective
    ],

    providers: [
        {
            provide: MatDialogRef,
            useValue: {}
        }
    ],

    bootstrap: [AppComponent]
})
export class AppModule {}
